import useTranslation from "next-translate/useTranslation";
import classes from "./style.module.css";
import linkList from "./listing_lists.json";
import { useEffect, useRef, useState } from "react";
import formatUrl from "utils/FormatUrl";
function ListingsSubList({
  onlyPopularSearch = false,
  province = "Casablanca",
  quartier = "",
  transaction_type,
  type,
  currentListing,
}: {
  onlyPopularSearch?: boolean;
  province?: string;
  quartier?: string;
  transaction_type: string;
  type?: string;
  currentListing?: boolean;
}) {
  const { t, lang } = useTranslation("annonceAchat");

  const [links_to_display, setLinks] = useState(
    currentListing
      ? linkList[province]
        ? linkList[province][quartier]
          ? linkList[province][quartier][transaction_type]
            ? linkList[province][quartier][transaction_type][type]
                ?.onCurrentListing
              ? linkList[province][quartier][transaction_type][type]
                  ?.onCurrentListing
              : {
                  all: [],
                }
            : {
                all: [],
              }
          : linkList[province][transaction_type] && !quartier
          ? linkList[province][transaction_type][type]?.onCurrentListing
            ? linkList[province][transaction_type][type]?.onCurrentListing
            : {
                all: [],
              }
          : {
              all: [],
            }
        : {
            all: [],
          }
      : linkList[province]
      ? linkList[province][quartier]
        ? linkList[province][quartier][transaction_type]
          ? linkList[province][quartier][transaction_type][type ? type : "all"]
            ? linkList[province][quartier][transaction_type][
                type ? type : "all"
              ]
            : {
                all: [],
              }
          : {
              all: [],
            }
        : linkList[province][transaction_type] && !quartier
        ? linkList[province][transaction_type][type ? type : "all"]
          ? linkList[province][transaction_type][type ? type : "all"]
          : {
              all: [],
            }
        : {
            all: [],
          }
      : {
          all: [],
        }
  );

  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    } else {
      setLinks(
        currentListing
          ? linkList[province]
            ? linkList[province][quartier]
              ? linkList[province][quartier][transaction_type]
                ? linkList[province][quartier][transaction_type][type]
                    ?.onCurrentListing
                  ? linkList[province][quartier][transaction_type][type]
                      ?.onCurrentListing
                  : {
                      all: [],
                    }
                : {
                    all: [],
                  }
              : linkList[province][transaction_type] && !quartier
              ? linkList[province][transaction_type][type]?.onCurrentListing
                ? linkList[province][transaction_type][type]?.onCurrentListing
                : {
                    all: [],
                  }
              : {
                  all: [],
                }
            : {
                all: [],
              }
          : linkList[province]
          ? linkList[province][quartier]
            ? linkList[province][quartier][transaction_type]
              ? linkList[province][quartier][transaction_type][
                  type ? type : "all"
                ]
                ? linkList[province][quartier][transaction_type][
                    type ? type : "all"
                  ]
                : {
                    all: [],
                  }
              : {
                  all: [],
                }
            : linkList[province][transaction_type] && !quartier
            ? linkList[province][transaction_type][type ? type : "all"]
              ? linkList[province][transaction_type][type ? type : "all"]
              : {
                  all: [],
                }
            : {
                all: [],
              }
          : {
              all: [],
            }
      );
    }
  }, [province, transaction_type, type]);
  return (
    <div className={classes.container}>
      <div className={classes.inner}>
        {currentListing ? (
          links_to_display?.length && !onlyPopularSearch ? (
            <div className={classes.link_container_item}>
              <p className={classes.link_container_title}>{t("Voir aussi")}</p>
              <div className={`${classes.links} ${classes.flex_row}`}>
                {links_to_display?.map((item, key) => {
                  return (
                    <a
                      key={key}
                      className={`${classes.link} ${classes.flex_row_link}`}
                      rel={
                        item.url.includes("list") ||
                        item.url.includes("map") ||
                        item.url.includes("?") ||
                        item.url.includes("conditions") ||
                        item.url.includes("contact")
                          ? "nofollow noopener noreferrer noindex"
                          : "follow"
                      }
                      href={formatUrl(item.url)}
                    >
                      {t(item.text)}
                    </a>
                  );
                })}
              </div>
            </div>
          ) : null
        ) : null}
        {links_to_display.all?.length && !onlyPopularSearch ? (
          <div className={classes.link_container_item}>
            <p className={classes.link_container_title}>{t("Voir aussi")}</p>
            <div className={`${classes.links} ${classes.flex_row}`}>
              {links_to_display.all?.map((item, key) => {
                return (
                  <a
                    key={key}
                    className={`${classes.link} ${classes.flex_row_link}`}
                    rel={
                      item.url.includes("list") ||
                      item.url.includes("map") ||
                      item.url.includes("?") ||
                      item.url.includes("conditions") ||
                      item.url.includes("contact")
                        ? "nofollow noopener noreferrer noindex"
                        : "follow"
                    }
                    href={formatUrl(item.url)}
                  >
                    {t(item.text)}
                  </a>
                );
              })}
            </div>
          </div>
        ) : null}
        {onlyPopularSearch && links_to_display.populaires?.length ? (
          <div className={classes.link_container_item}>
            <p className={classes.link_container_title}>
              {t("Recherches populaires")}
            </p>
            <div className={classes.links}>
              {links_to_display.populaires?.map((item, key) => {
                return (
                  <a
                    key={key}
                    rel={
                      item.url.includes("list") ||
                      item.url.includes("map") ||
                      item.url.includes("?") ||
                      item.url.includes("conditions") ||
                      item.url.includes("contact")
                        ? "nofollow noopener noreferrer noindex"
                        : "follow"
                    }
                    className={classes.link}
                    href={formatUrl(item.url)}
                  >
                    {t(item.text)}
                  </a>
                );
              })}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default ListingsSubList;
